export const CONVERSATION_HEIGHT = 500;

export const PROSPECT_PREFIX = 'prospect-';
export const CUSTOMER_PREFIX = 'customer-';
export const NEW_CONV_SUFFIX = '-new-conv';
export const MESSAGE_LIMIT = 10;
